import BaseComponent from '@utils/base.js';
import tag from '@utils/utilTags.js';
import TopHint from '@components/field/topHint/topHint.js';
import SideHint from '@components/field/sideHint/sideHint.js';
import Nonogram from './nonogram/nonogram.js';

import * as styles from './field.module.scss';

/** @extends {BaseComponent<HTMLDivElement>} */
export default class Field extends BaseComponent {
  constructor() {
    super({ classes: [styles.field] });

    window.addEventListener(
      'custom:renderNonogram',
      /** @type {EventListener} */ (
        (
          /** @type {CustomEvent<{nonogram: NonogramData, isGameLoaded: boolean, solving?: number[][]}>} */ e
        ) => this.renderNonogramField(e.detail)
      )
    );
  }

  /**
   * Appends a nonogram puzzle to the game field.
   * @param {{nonogram: NonogramData, isGameLoaded: boolean, solving?: number[][]}} data
   * @returns {void}
   * @private
   */
  renderNonogramField(data) {
    const { nonogram, isGameLoaded, solving } = data;

    this.removeChildren();
    const heading = tag.h1({
      classes: [styles.heading],
      text: nonogram.name,
    });
    const topHint = new TopHint({
      classes: [styles.topHint],
      nonogram: nonogram.solution,
      difficulty: nonogram.difficulty,
    });
    const sideHint = new SideHint({
      classes: [styles.sideHint],
      nonogram: nonogram.solution,
      difficulty: nonogram.difficulty,
    });
    const nonogramComponent = new Nonogram({
      classes: [styles.nonogram],
      nonogram: solving ? solving : nonogram.solution,
      isGameLoaded: isGameLoaded,
      difficulty: nonogram.difficulty,
    });

    this.appendChildren(heading, topHint, sideHint, nonogramComponent);
  }
}
